var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 17,
    viewBox: "0 0 97 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_12180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.670166,
    y: 0.439941,
    width: 95.99,
    height: 15.99,
    rx: 7.995,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.670166 0.439941H96.6602V16.4299H0.670166V0.439941Z",
    fill: "url(#paint0_linear_130_12180)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_12180",
    x1: 0.670166,
    y1: 8.43494,
    x2: 96.6602,
    y2: 8.43494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE498"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_12180"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.670166,
    y: 0.439941,
    width: 95.99,
    height: 15.99,
    rx: 7.995,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMix);
export default __webpack_public_path__ + "static/media/mix.95a48758276dea524f04dd97918057a9.svg";
export { ForwardRef as ReactComponent };